import * as en from './en';
import * as es from './es';

export const languages = {
  en,
  es,
};
